import React, {
  useEffect,
  useCallback,
  useRef,
  useState,
  lazy,
  Suspense,
} from "react";
import { Helmet } from "react-helmet";
import Foto1 from "../img/Foto1.jpg";
import Foto2 from "../img/Foto2.jpg";
import Foto3 from "../img/Foto3.jpg";
import Fondo from "../img/ilustracioncusco.jpg";
import SocialShare from "../components/SocialShare";
import { useCountUp } from "react-countup";
import { Fade } from "react-awesome-reveal";
import Author from "../img/jose victor salcedo ccama.jpg";
import ManuelSalinas from "../img/Manuel Salinas Zapata.jpg";
import OscarM from "../img/Oscar Mollohuanca Cruz.jpg";
import Florentino from "../img/Florentino Laime Mantilla.jpg";
import Domingo from "../img/Domingo Benito Calderón.jpg";
import DavidVera from "../img/David Vera Castillo.jpg";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const SimpleCounter = ({ end }) => {
  const { countUp } = useCountUp({ end });
  return <span>{countUp}</span>;
};

const Cusco1 = lazy(() => import("../charts/Cusco1"));
const Cusco2 = lazy(() => import("../charts/Cusco2"));

const NotaCusco = () => {
  const handleScroll = useCallback((event) => {
    let scrollTop = window.scrollY + window.innerHeight;
    if (window.innerWidth > 400) {
      if (
        !showCusco1 &&
        refCusco1.current &&
        refCusco1.current.offsetTop < scrollTop
      ) {
        setShowCusco1(true);
      }

      if (
        !showCusco2 &&
        refCusco2.current &&
        refCusco2.current.offsetTop < scrollTop - 250
      ) {
        setShowCusco2(true);
      }

      if (
        !showCounter &&
        refCounter.current &&
        refCounter.current.offsetTop < scrollTop
      ) {
        setShowCounter(true);
      }
    } else {
      if (
        !showCusco1 &&
        refCusco1.current &&
        refCusco1.current.offsetTop < scrollTop - 200
      ) {
        setShowCusco1(true);
      }

      if (
        !showCusco2 &&
        refCusco2.current &&
        refCusco2.current.offsetTop < scrollTop - 350
      ) {
        setShowCusco2(true);
      }

      if (
        !showCounter &&
        refCounter.current &&
        refCounter.current.offsetTop < scrollTop - 200
      ) {
        setShowCounter(true);
      }
    }

    //console.log(scrollTop );  //1,2,...100,...200...etc (in px)
  });

  const refCusco1 = useRef(null);
  const refCusco2 = useRef(null);
  const refCounter = useRef(null);

  const [showCusco1, setShowCusco1] = useState(false);
  const [showCusco2, setShowCusco2] = useState(false);
  const [showCounter, setShowCounter] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll, false);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="nota">
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Pobreza y corrupción en dos provincias mineras del Cusco
          </title>
          <meta
            property="og:title"
            content="Pobreza y corrupción en dos provincias mineras del Cusco"
          />
          <meta
            name="description"
            content="Entre 2005 y 2019 las municipalidades espinarenses
                  recibieron 1000 millones de soles por canon y regalías
                  mineras, mientras que las chumbivilcanas, 200 millones"
          ></meta>
          <meta
            property="og:url"
            content={
              process.env.REACT_APP_URL +
              "/pobreza-corrupcion-provincias-mineras-cusco"
            }
          />
          <meta property="og:image" content={"https://fundacionmohme.org"+Fondo} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image:src" content={"https://fundacionmohme.org"+Fondo} />
        </Helmet>
        <div>
          <header className="">
            <div className="header-bg">
              <img
                className="img-fluid"
                src={Fondo}
                alt="Pobreza y corrupción en dos provincias mineras del Cusco"
              />
            </div>
            <div className="nota-header-content  ">
              <div className="container d-flex justify-content-center flex-column">
                <Fade delay={80} triggerOnce>
                  <h1>
                    Pobreza y corrupción en dos provincias mineras del Cusco
                  </h1>
                  <SocialShare
                    url={
                      process.env.REACT_APP_URL +
                      "/pobreza-corrupcion-provincias-mineras-cusco"
                    }
                    text="Pobreza y corrupción en dos provincias mineras del Cusco"
                  />

                  <p className="bajada d-none d-lg-block d-md-none">
                    Las empresas Antapaccay y Hudbay extraen cobre en las
                    provincias cusqueñas de Espinar y Chumbivilcas. Por esta
                    actividad, entre 2005 y 2019 las municipalidades
                    espinarenses recibieron 1000 millones de soles por canon y
                    regalías mineras, mientras que las chumbivilcanas, 200
                    millones. En contraste, una parte importante de sus
                    habitantes sigue viviendo en la pobreza. La procuraduría
                    anticorrupción reporta 77 procesos penales por presunta
                    corrupción en estas dos provincias.
                  </p>
                </Fade>
              </div>
            </div>
          </header>
        </div>
        <main>
          <div className="container">
            <Fade delay={80}>
              <p className="bajada d-none d-block d-lg-none">
                Las empresas Antapaccay y Hudbay extraen cobre en las provincias
                cusqueñas de Espinar y Chumbivilcas. Por esta actividad, entre
                2005 y 2019 las municipalidades espinarenses recibieron 1000
                millones de soles por canon y regalías mineras, mientras que las
                chumbivilcanas, 200 millones. En contraste, una parte importante
                de sus habitantes sigue viviendo en la pobreza. La procuraduría
                anticorrupción reporta 77 procesos penales por presunta
                corrupción en estas dos provincias.
              </p>
            </Fade>
          </div>
          <div className="container">
            <Fade delay={80}>
              <div className="author d-flex">
                <div className="circle">
                  <img
                    src={Author}
                    className="img-fluid"
                    alt="José Víctor Salcedo"
                  />
                </div>
                Por José Víctor Salcedo - La República - Cusco
              </div>
            </Fade>
            <Fade delay={80}>
              <p>
                <span className="capital-letter">D</span>e lejos, Alto Huancané
                parece un pueblo fantasma. De cerca, el viento sopla y hace
                silbar el ichu, acentuando más la soledad. Alto Huancané es una
                comunidad campesina de las alturas de la provincia de Espinar, a
                cinco horas de viaje del Cusco, con unos quinientos habitantes
                dedicados a la agricultura de autoconsumo y la ganadería.
              </p>
              <p>
                Las casas en Alto Huancané son de adobe. Las paredes,
                recubiertas de barro, lucen envejecidas y se deshacen como
                costras. Por dentro, el piso es de tierra y los comuneros
                duermen sobre los cueros disecados de ovejas, llamas o alpacas.
              </p>

              <p>
                Doña Melchora Surco Rimachi nació y vive, hace 65 años, en el
                sector Paccpacco, un paraje cercano a la enorme mina de cobre
                Tintaya, que funcionó hasta el 2011. Su rostro y corazón están
                arrugados por las heladas que caen como latigazos en los Andes.
                También por las peleas que ha librado contra la carencia y “las
                injusticias”, cuando era presidenta de la Asociación para la
                Defensa de Paccpacco Afectada por la Minería (ADEPAMI).
              </p>

              <p>
                En el último quinquenio su lucha se concentró en conseguir
                atención médica para los comuneros de Alto Huancané y Huisa (una
                comunidad vecina), contaminados con 17 metales tóxicos. La
                empresa Xstrata, ahora Antapaccay Glencore, cerró la mina en
                2011, pero sus secuelas o efectos, según la lideresa indígena,
                persisten. En 2013, 180 comuneros se enteraron que en sus
                cuerpos cargaban metales pesados. El Centro Nacional de Salud
                Ocupacional y Protección del Ambiente para la Salud (Censopas)
                del Ministerio de Salud halló en sus orinas plomo, talio,
                manganeso, cadmio, arsénico, mercurio, entre otras sustancias,
                que dañan los órganos del cuerpo.
              </p>
            </Fade>
          </div>
          <Fade delay={80}>
            <div className="img-container">
              <img
                className="img-fluid full-width"
                src={Foto1}
                alt="Melchora Surco Rimachi"
              />
              <div className="img-legend">Melchora Surco Rimachi</div>
            </div>
          </Fade>
          <div className="container">
            <Fade delay={80}>
              <p>
                Lo que no quedó establecido es si la mina era la causante de la
                contaminación. Los estudios que realizó en esa ocasión la
                entidad estatal solo señalan la presencia de metales tóxicos,
                pero no precisan la fuente contaminante. En la mesa de diálogo,
                instalada en mayo de 2012, luego de un paro que dejó dos
                fallecidos, el Gobierno prometió realizar un estudio. Han pasado
                8 años y ese compromiso no se cumple.
              </p>
              <p>
                Los pobladores de Paccpacco habitan un territorio de pastos
                secos y montañas desnudas de vegetación durante la mayor parte
                del año. Muy cerca se divisan los restos del antiguo centro de
                donde extraían cobre y otros minerales hasta el 2011: la mina
                Tintaya.
              </p>
              <p>
                En 1980, el proyecto surgió como una buena nueva y muchos
                auguraban desarrollo y mejores ingresos para los pobladores.
              </p>

              <p>
                "No fue así. Solo algunos se beneficiaron y la mayoría hemos
                sido perjudicados", cuestiona doña Melchora, mientras busca en
                sus recuerdos cómo empezó todo.
              </p>
              <p>
                La mina Tintaya era de la Empresa Minera Especial Tintaya S.A.
                de propiedad del Estado peruano. En 1994, el periodo de las
                privatizaciones del régimen fujimorista, la mina fue comprada
                por el consorcio estadounidense Magma Cooper Company, que luego
                fue absorbida por Broken Hill Proprietary (BHP), que a su vez se
                fusionó posteriormente con la empresa Billiton. Después la mina
                pasó a manos de Xtrata y ahora la posee Antapaccay-Glencore.
              </p>
              <p>
                Volvamos a 1980. Aquel año el Gobierno promovió la expropiación
                de 2368 hectáreas de tierras a las comunidades. Al final, el
                proyecto abarcó 4000 hectáreas. En 1984, empezó la explotación
                de Tintaya y se convirtió en la tercera productora de cobre del
                país. Cuando esta mina cerró empezó a operar su hermana:
                Antapaccay, operada por la minera suiza Glencore.
              </p>
              <p>
                Según documentó la organización Derechos Humanos Sin Fronteras
                (DHSF), en 2012, la producción de cobre en la mina Antapaccay
                fue de 51 mil 876 toneladas métricas y en 2018 subió a 201 mil
                414 toneladas. Las ventas anuales en 2016 significaron para
                Glencore Antapaccay S/ 3 mil 690 millones 612 mil.
              </p>
              <p>
                Cuatro décadas después, el descontento está latente. Los
                gobernantes de Espinar no usaron adecuadamente el dinero del
                canon y regalías mineras. El 15 de julio pasado estalló una vez
                más un conflicto. Los ciudadanos, agobiados económicamente por
                la crisis sanitaria, reclamaron con protestas y lograron la
                entrega de un subsidio de S/ 1000 en tarjetas de uso múltiple
                para cada elector con dinero del Convenio Marco, institución que
                maneja este fondo constituido por el aporte del 3% de utilidades
                anuales de Antapaccay.
              </p>
              <h2>Vivir con dos horas de agua potable al día</h2>
              <p>
                Son las diez de la mañana de un jueves de julio en Espinar. El
                profesor y ex dirigente sindical Herbert Huamán Llave abre las
                llaves del caño. Sale aire, no agua. En Yauri, capital de
                Espinar, las familias solo tienen dos o tres horas de agua
                potable al día. En las comunidades campesinas como Alto Huancané
                todavía se consume agua entubada de ríos o manantiales.
              </p>
              <p>
                "Llevamos más de 30 años esperando tener agua potable todo el
                día. Las autoridades no han sabido usar el dinero que han
                recibido para mejorar la vida de la gente y la minera tampoco
                tuvo intención de ayudarnos", se queja don Herbert.
              </p>
            </Fade>
          </div>
          <Fade delay={80}>
            <div className="img-container">
              <img
                className="img-fluid full-width"
                src={Foto2}
                alt="Herbert Huamán Llave"
              />
              <div className="img-legend">Herbert Huamán Llave</div>
            </div>
          </Fade>
          <div className="container">
            <Fade delay={80}>
              <p>
                Él fue dirigente sindical en el 2012. En mayo de aquel año
                impulsó -junto a otros líderes sociales- una protesta contra la
                minera a la que acusaban de contaminar los campos y las fuentes
                de agua. El paro dejó dos muertos y denuncias penales en su
                contra. Nueve años después, la Fiscalía pide más de 20 años para
                él y otros exdirigentes y exautoridades por los delitos de
                atentado contra la seguridad pública, disturbios y otros.
              </p>
              <p>
                Aquella vez, para apaciguar la sed de la población, el Gobierno
                asumió el compromiso de elaborar un proyecto de inversión para
                llevar agua potable a todos los hogares. El compromiso solo
                quedó escrito en un acta. La Municipalidad Provincial de Espinar
                tampoco usó dinero del canon recibido para un proyecto que
                asegure agua para las 20 mil familias de Yauri, capital de
                Espinar. Allí, además, los desechos de desagüe van a contaminar
                las aguas del río Cañipía.
              </p>
              <p>
                El año pasado recién se aprobó el proyecto del sistema integral
                de agua potable y desagüe. La obra se hará en conjunto con
                Antapaccay con una inversión superior a S/ 170 millones. La
                empresa lo financiará mediante la modalidad de obras por
                impuestos. “Se está reformulando el proyecto y eso debe concluir
                en tres o cuatro meses si la pandemia no lo demora más. Luego,
                se hará la licitación y esperamos contar pronto con el servicio
                continuo”, asegura Werner Salcedo Álvarez, gerente municipal de
                la comuna provincial de Espinar.
              </p>
              <h2>La corrupción municipal</h2>
              <p>
                Los ocho distritos y la provincia de Espinar recibieron casi
                1000 millones de soles por canon y regalías mineras solo entre
                2005 y 2019. Parte de ese dinero, según denuncias que investiga
                el Ministerio Público, se perdió en obras sin importancia como
                un coliseo cerrado gigante en Yauri o “proyectos de desarrollo”
                que no impulsaron ninguna mejora o favorecieron a empresarios y
                funcionarios acusados ahora de corruptos.
              </p>
              <p>
                “El coliseo costó casi S/ 30 millones y nadie sabe su utilidad
                hasta ahora”, observa el economista del Centro Bartolomé de Las
                Casas, Pablo Villa Incanttito.
              </p>
              <p>
                Chumbivilcas, después de Espinar, es la segunda provincia en
                volumen producción minera del Cusco. En diciembre de 2014 empezó
                a operar la mina Constancia de Hudbay Perú en tierra de los
                q’orilazos –así se les llama a los habitantes de esta provincia
                cusqueña-. Derechos Humanos Sin Fronteras documentó que en 2015
                la producción de cobre alcanzó 106 063 toneladas métricas (TMF)
                y en el 2018 subió a 122 178 TMF. Según el reporte, esas
                cantidades son superiores a las 70 533 toneladas anuales que
                estaban previstas en el 2010.
              </p>
              <p>
                Las transferencias a la provincia y los distritos aumentaron
                desde el inicio de operaciones de Constancia. Entre 2005 y 2019,
                las comunas recibieron más de S/ 200 millones por canon y
                regalías mineras. Desde el 2015 hubo regalías -pagadas por
                Hudbay- entre S/ 5 y 17 millones, mientras que el canon recién
                empezó a entregarse en 2018 superando una transferencia de S/ 22
                millones. Los distritos de Velille, Chamaca y Livitaca, y la
                provincia de Chumbivilcas, reciben la mayor tajada.
              </p>
            </Fade>

            <div className="container-chart" ref={refCusco1}>
              {showCusco1 && (
                <Suspense fallback={null}>
                  <Fade delay={80}>
                    <h3>
                      TRANSFERENCIAS POR CANON Y REGALÍAS MINERAS PARA ESPINAR
                      <br></br>
                      <small>
                        FUENTE:{" "}
                        <a href="https://mapainversiones.minem.gob.pe/">
                          MEF-MINEM
                        </a>
                      </small>
                    </h3>

                    <Cusco1 />
                  </Fade>
                </Suspense>
              )}
            </div>

            <div className="container-chart" ref={refCusco2}>
              <Fade>
                <h3>
                  TRANSFERENCIAS POR CANON Y REGALÍAS MINERAS PARA CHUMBIVILCAS{" "}
                  <br></br>
                  <small>
                    FUENTE:{" "}
                    <a href="https://mapainversiones.minem.gob.pe/">
                      MEF-MINEM
                    </a>
                  </small>
                </h3>
              </Fade>
              {showCusco2 && (
                <Suspense fallback={null}>
                  <Fade delay={80}>
                    <Cusco2 />
                  </Fade>
                </Suspense>
              )}
            </div>
            <Fade delay={80}>
              <p>
                Lo preocupante es que hay fuertes indicios de que parte del
                dinero se perdió en corrupción. La Procuraduría Especializada en
                Delitos de Corrupción de Funcionarios del Cusco, a cargo del
                abogado José María Gavancho Ninantay, defiende al Estado en 42
                de procesos penales por corrupción en Espinar y en 35 en
                Chumbivilcas. En varios casos están involucrados ex autoridades,
                funcionarios y proveedores por delitos de peculado, colusión,
                malversación de fondos y negociación incompatible. “Hubo una
                mezcla de actos de corrupción y gobiernos que no supieron
                priorizar el uso del dinero para mejorar la calidad de vida”,
                apunta Pablo Villa.
              </p>
              <p>
                Mientras que Salcedo Álvarez señala que en Espinar hubo
                bastantes irregularidades en las gestiones pasadas. “Basta poner
                el dedo para que salte el pus. Hay ocho casos emblemáticos de
                corrupción que involucran a ex autoridades municipales”,
                explicó.
              </p>
              <h2>Los investigados</h2>
            </Fade>

            <div
              className="container container-chart procesos-cusco"
              ref={refCounter}
            >
              <Fade delay={80}>
                <h3 className="mb-5">
                  PROCESOS E INVESTIGACIÓN POR CORRUPCIÓN
                </h3>
              </Fade>
              {showCounter && (
                <Fade>
                  <div className="row justify-content-center text-center mb-4">
                    <div className="col-sm-3">
                      <div className="casos-ing">
                        <SimpleCounter end={42} /> casos investigados en{" "}
                        <strong>Espinar</strong>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="casos-ing">
                        <SimpleCounter end={35} /> casos investigados en{" "}
                        <strong>Chumbivilcas</strong>
                      </div>
                    </div>
                  </div>
                </Fade>
              )}

              <Fade delay={80}>
                <h3 className="mb-3 casos">CASOS EMBLEMÁTICOS</h3>
                <div className="row justify-content-center text-center casos-emblematicos">
                  <div className="col-sm-4 caso-item-bg">
                    <div className="caso-item">
                      <div className="caso-img mt-2">
                        <img
                          className="img-fluid"
                          src={ManuelSalinas}
                          alt="Manuel Salinas Zapata"
                        />
                      </div>
                      <h6>Manuel Salinas Zapata</h6>
                      <small>Exalcalde Espinar (2015-2018)</small>
                      <p className="mt-2">
                        Ocho denuncias por peculado doloso, malversación de
                        fondos, negociación incompatible o aprovechamiento
                        indebido del cargo y omisión de actos funcionales.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 caso-item-bg">
                    <div className="caso-item">
                      <div className="caso-img mt-2">
                        <img
                          className="img-fluid"
                          src={OscarM}
                          alt="Óscar Mollohuanca Cruz"
                        />
                      </div>
                      <h6>Óscar Mollohuanca Cruz</h6>
                      <small>Exalcalde Espinar (2011-2014)</small>
                      <p className="mt-2">
                        Ocho procesos en las modalidades de peculado doloso y
                        malversación de fondos.{" "}
                      </p>
                    </div>
                  </div>

                  <div className="col-sm-4 caso-item-bg">
                    <div className="caso-item">
                      <div className="caso-img mt-2">
                        <img
                          className="img-fluid"
                          src={DavidVera}
                          alt="David Vera Castillo"
                        />
                      </div>
                      <h6>David Vera Castillo</h6>
                      <small>Exalcalde Chumbivilcas</small>
                      <p className="mt-2">
                        Cinco denuncias por colusión, peculado doloso agravado,
                        cohecho pasivo impropio, malversación y retardo
                        injustificado de pago.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 caso-item-bg">
                    <div className="caso-item">
                      <div className="caso-img mt-2">
                        <img
                          className="img-fluid"
                          src={Florentino}
                          alt="Florentino Laime Mantilla"
                        />
                      </div>
                      <h6>Florentino Laime Mantilla</h6>
                      <small>Exalcalde Chumbivilcas</small>
                      <p className="mt-2">
                        Seis investigaciones por peculado doloso y malversación
                        de fondos
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-4 caso-item-bg">
                    <div className="caso-item">
                      <div className="caso-img mt-2">
                        <img
                          className="img-fluid"
                          src={Domingo}
                          alt="Domingo Benito CalderónF"
                        />
                      </div>
                      <h6>Domingo Benito Calderón </h6>
                      <small>Exalcalde Chumbivilcas</small>
                      <p className="mt-2">
                        Un proceso por peculado y malversación de fondos.
                      </p>
                    </div>
                  </div>
                </div>
              </Fade>
            </div>

            <Fade delay={80}>
              <p>
                En la lista de exalcaldes del Espinar investigados está Manuel
                Salinas Zapata (2015-2018) con ocho denuncias. Una es por haber
                encargado a Condhydra SAESP Sucursal Perú la elaboración del
                expediente del proyecto de agua potable y saneamiento de la
                ciudad de Yauri. Condhydra debía cobrar por ese trabajo S/ 6
                millones en tres partidas. Cobró S/ 4 millones 100 mil soles,
                pero el trabajo presentaba deficiencias.
              </p>
              <p>
                Óscar Mollohuanca Cruz (2011-2014) también tiene ocho denuncias
                por corrupción de funcionarios en las modalidades de peculado
                doloso y malversación de fondos, según un reporte de la
                procuraduría Anticorrupción.
              </p>

              <p>
                De igual forma, los tres últimos alcaldes de Chumbivilcas son
                investigados. El exalcalde David Vera Castillo tiene cinco
                denuncias en curso por colusión, peculado doloso agravado,
                cohecho pasivo impropio, malversación y retardo injustificado de
                pago. Su antecesor, Florentino Laime Mantilla, cuenta con seis
                investigaciones por peculado doloso y malversación de fondos. Y
                el anterior a este, Domingo Benito Calderón, afronta un proceso
                por peculado y malversación de fondos.
              </p>
              <p>
                “Los procedimientos de selección que se efectúan para la
                inversión de proyectos con dinero del Estado generalmente
                implican otorgar la buena pro a empresas que tienen vinculación
                sea con los funcionarios o servidores públicos o con la propia
                autoridad que dirige la gestión. He allí otro de los factores
                que influye en la corrupción y en perpetuar la pobreza”, analiza
                Henry Delgado Urrutia, ex procurador anticorrupción del Cusco.
              </p>
              <p>
                Según el informe “La corrupción en los gobiernos regionales y
                locales” de la Procuraduría Nacional del 2019, a nivel nacional
                había 4225 casos y 2059 autoridades investigadas. Cusco tenía en
                toda la región 439 investigados, de los cuales 203 eran o habían
                sido autoridades: cinco ex gobernadores regionales, 38 alcaldes
                provinciales y 160 distritales. Así, la región imperial ocupaba
                el primer lugar en este deshonroso ranking.
              </p>
              <h2>El polvo del descontento</h2>
              <p>
                Germán Salcedo Quispe, expresidente del Frente Único de Defensa
                de los Intereses de Velille, ve cómo una serpiente de camiones
                encapsulados traslada miles de toneladas de cobre, oro, plata y
                otros minerales hacia el puerto de Matarani, en Arequipa, para
                embarcar el cargamento con destino a Europa o Asia. Cada día
                cuenta 370 camiones de las empresas MMG Las Bambas y Hudbay
                Perú. Cada camión transporta 34 toneladas de minerales. Detrás
                de ellos, una nube de polvo, que es la nube del descontento,
                enceguece al líder campesino de Chumbivilcas, por donde pasa el
                Corredor Minero del Sur, una vía que facilita la salida de los
                camiones de las minas Las Bambas en Cotabambas (Apurímac) y
                Constancia en Cusco.
              </p>
              <p>
                "Vemos cómo se llevan nuestras riquezas y aquí seguimos siendo
                pobres. Y nuestros campos están dejando de producir", se queja
                Salcedo Quispe. “Nuestra riqueza se la llevan otros”, repite
                imprimiendo más contundencia a sus palabras.
              </p>
              <p>
                Según el estudio de impacto ambiental de Las Bambas, modificado
                en 2014, la flota es de 125 camiones cargados por día y 125
                camiones de retorno sin carga; además de 60 vehículos que
                abastecen de insumos al campamento minero en el distrito de
                Challhuahuacho (Apurímac). “Son más vehículos los que pasan.
                Cada vez son más y nosotros sufrimos sus efectos de
                contaminación”, señala enfático Germán Salcedo.
              </p>
              <p>
                El polvo causa descontento. Un estudio del Organismo de
                Evaluación y Fiscalización Ambiental (OEFA) concluyó en 2019 que
                el paso de camiones provoca contaminación al generar polvareda y
                afectar el aire que respiran las personas de los pueblos
                asentados en ambos lados del corredor vial.
              </p>
              <p>
                OEFA instaló 26 puntos de monitoreo en el corredor minero en
                territorio chumbivilcano para analizar si hay contaminación
                sonora. En 22 exceden los estándares de calidad (ECA) para
                ruido. El aire está contaminado en dos puntos por el paso de
                camiones que generan material particulado (polvo) y de 12
                estaciones de monitoreo, dos registran excesos en el ECA Aire.
              </p>
              <p>
                También evaluaron los niveles de polvo sedimentado. No obstante,
                en Perú no existe normativa para medir esos índices, por lo que
                se tomó de referencia la de la Organización Mundial de la Salud
                (OMS) y de Australia: en 13 sitios excede los niveles
                permitidos.
              </p>
              <h2>Pobreza en entornos mineros</h2>
              <p>
                En las zonas donde operan las mineras y los municipios reciben
                transferencias por canon y regalías, la población sigue siendo
                pobre. Se considera pobre a aquella persona que no puede comprar
                una canasta alimentaria que supere S/ 352 al mes, es decir, S/
                11.73 diarios. Por familia (cuatro miembros en promedio) el
                monto sería de S/ 1408 mensuales.
              </p>
              <p>
                Según el Mapa de pobreza monetaria provincial y distrital 2018
                del Instituto Nacional de Estadística e Informática (INEI), en
                la provincia de Chumbivilcas los índices de pobres oscilan entre
                41.8 y 54.5% (casi el doble del promedio regional que es de
                26.5%), mientras que el 55% de niños menores de 3 años está
                enfermo de anemia. En los distritos de Chamaca, Velille y
                Livitaca, zonas de influencia directa de la mina Constancia, el
                número de pobres, es decir, ciudadanos viven con menos de S/ 12
                diarios, varía entre 26.1 y 69.9%.
              </p>
              <p>
                “Si las zonas más pobres del Perú carecen de los servicios
                básicos por el olvido de sus autoridades, la corrupción tiene un
                impacto más devastador en su desarrollo. El aprovechamiento
                indebido de los recursos públicos, el cohecho y la negociación
                incompatible hacen predictible perpetuar la pobreza”, precisa
                Henry Delgado.
              </p>
            </Fade>
            <Fade delay={80}>
              <div className="container-chart cuadros">
                <h3>
                  MAPA DE POBREZA MONETARIA PROVINCIAL Y DISTRITAL EN ESPINAR Y
                  CHUMBIVILCAS AL 2018
                </h3>
                <h6 className="mb-3">
                  <strong>CHUMBIVILCAS</strong>
                </h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th rowSpan="2"></th>
                      <th rowSpan="2" className="text-right">
                        POBLACIÓN PROYECTADA 2020
                      </th>
                      <th className="text-center" colSpan="2">
                        INTERVALOS DE CONFIANZA AL 95%
                      </th>
                    </tr>
                    <tr>
                      <th scope="col" className="text-right">
                        INFERIOR
                      </th>
                      <th scope="col" className="text-right">
                        SUPERIOR
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="resaltar">
                      <th scope="row">PROVINCIA CHUMBIVILCAS</th>
                      <td className="text-right">70 143</td>
                      <td className="text-right">41,8</td>
                      <td className="text-right">54,5</td>
                    </tr>
                    <tr>
                      <th scope="row">Santo Tomás </th>
                      <td className="text-right">22 809</td>
                      <td className="text-right">31,2</td>
                      <td className="text-right">57,7</td>
                    </tr>
                    <tr>
                      <th scope="row">Capacmarca</th>
                      <td className="text-right"> 4 119 </td>
                      <td className="text-right">30,3 </td>
                      <td className="text-right">60,1</td>
                    </tr>
                    <tr>
                      <th scope="row">Chamaca</th>
                      <td className="text-right">6 503</td>
                      <td className="text-right">35,4</td>
                      <td className="text-right">62,5</td>
                    </tr>
                    <tr>
                      <th scope="row">Colquemarca</th>
                      <td className="text-right">7 110 </td>
                      <td className="text-right">34,8 </td>
                      <td className="text-right">63,5</td>
                    </tr>
                    <tr>
                      <th scope="row">Livitaca </th>
                      <td className="text-right">12 798 </td>
                      <td className="text-right">44,2 </td>
                      <td className="text-right">69,9</td>
                    </tr>
                    <tr>
                      <th scope="row">Llusco </th>
                      <td className="text-right">4 322 </td>
                      <td className="text-right">36,3 </td>
                      <td className="text-right">63,7</td>
                    </tr>
                    <tr>
                      <th scope="row">Quiñota</th>
                      <td className="text-right">4 010 </td>
                      <td className="text-right">42,1 </td>
                      <td className="text-right">66,9</td>
                    </tr>
                    <tr>
                      <th scope="row">Velille </th>
                      <td className="text-right">8 472 </td>
                      <td className="text-right">26,1 </td>
                      <td className="text-right">51,4 </td>
                    </tr>
                  </tbody>
                </table>
                <h6 className="mb-3 mt-5">
                  <strong>ESPINAR</strong>
                </h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th rowSpan="2"></th>
                      <th rowSpan="2" className="text-right">
                        POBLACIÓN PROYECTADA 2020
                      </th>
                      <th className="text-center" colSpan="2">
                        INTERVALOS DE CONFIANZA AL 95%
                      </th>
                    </tr>
                    <tr>
                      <th scope="col" className="text-right">
                        INFERIOR
                      </th>
                      <th scope="col" className="text-right">
                        SUPERIOR
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="resaltar">
                      <th scope="row">PROVINCIA ESPINAR</th>
                      <td className="text-right">62 059 </td>
                      <td className="text-right">23,9 </td>
                      <td className="text-right">38,0</td>
                    </tr>
                    <tr>
                      <th scope="row">Espinar </th>
                      <td className="text-right">38 886 </td>
                      <td className="text-right">16,1</td>
                      <td className="text-right">35,7</td>
                    </tr>
                    <tr>
                      <th scope="row">Condoroma</th>
                      <td className="text-right">872</td>
                      <td className="text-right">12,3</td>
                      <td className="text-right">35,6</td>
                    </tr>
                    <tr>
                      <th scope="row">Coporaque</th>
                      <td className="text-right">9 824</td>
                      <td className="text-right">26,0</td>
                      <td className="text-right">57,2</td>
                    </tr>
                    <tr>
                      <th scope="row">Ocururo</th>
                      <td className="text-right">995</td>
                      <td className="text-right">23,8</td>
                      <td className="text-right">44,8</td>
                    </tr>
                    <tr>
                      <th scope="row">Pallpata</th>
                      <td className="text-right">5 111</td>
                      <td className="text-right">17,0</td>
                      <td className="text-right">42,8</td>
                    </tr>
                    <tr>
                      <th scope="row">Pichigua</th>
                      <td className="text-right">2 824</td>
                      <td className="text-right">30,6</td>
                      <td className="text-right">59,3</td>
                    </tr>
                    <tr>
                      <th scope="row">Suykuambo</th>
                      <td className="text-right">1 566</td>
                      <td className="text-right">28,0</td>
                      <td className="text-right">56,7</td>
                    </tr>
                    <tr>
                      <th scope="row">Alto Pichigua</th>
                      <td className="text-right">1 981</td>
                      <td className="text-right">23,8</td>
                      <td className="text-right">44,8</td>
                    </tr>
                  </tbody>
                </table>
                <small>
                  FUENTE: Mapa de pobreza monetaria provincial y distrital 2018
                  - INEI.
                </small>
              </div>
            </Fade>
            <Fade delay={80}>
              <p>
                De igual forma, Espinar tiene rostro de pobreza. Cinco (44.8%)
                de cada diez niños menores de tres años padece de anemia. Es la
                sexta provincia en la región imperial con más pequeños enfermos
                por una mala alimentación y deficiencia de hierro en la sangre,
                según un reporte de la Dirección Regional de Salud del 2019.
                Además, el mapa de pobreza del INEI, registra que la población
                pobre varía entre 23.9 y 38%.
              </p>
              <p>
                “La minería, aunque es visto como generadora de ingresos porque
                aporta al PBI, también es un sector que crea conflictos sociales
                y afecta la forma de vida, usos y costumbres de las comunidades.
                Si antes vivían del agro y la ganadería, ahora ya no ocurre eso.
                Por otro lado, no hay una adecuada priorización de proyectos
                municipales o del Estado que beneficien a los ciudadanos de
                Espinar. Y un tercer factor es la corrupción que impide el
                desarrollo”, explica el economista Pablo Villa.
              </p>
              <h2>Zona de conflictos</h2>
              <p>
                Antapaccay y Hudbay Perú no tienen una buena relación con las
                poblaciones de Espinar y Chumbivilcas. Hay tiempos de calma y
                otros turbulentos como se vivió en territorio espinarense entre
                el 15 de julio y 7 de agosto pasado. La ciudadanía empezó un
                paro por la negativa de la minera de entregar un bono de S/ 1000
                a cada elector. Al final, después de 23 días de protestas, que
                dejó heridos de bala, Antapaccay aceptó entregar el subsidio en
                tarjetas de uso múltiple. Es decir, si era posible dar el fondo,
                pero la minera no quería hacerlo. El Comité de Gestión del
                Convenio Marco, integrado por Antapaccay, alcaldes y dirigentes
                sociales y de comunidades, debe aprobar del uso de los fondos
                por unanimidad.{" "}
              </p>
              <div className="img-container">
                <img
                  className="img-fluid"
                  src={Foto3}
                  alt="Reciente paralización en Espinar"
                />
                <div className="img-legend">
                  Reciente paralización en Espinar
                </div>
              </div>
              <p>
                Esto no debe sorprender. De los 20 conflictos sociales
                registrados en región Cusco por la Defensoría del Pueblo en
                junio, 11 son socio ambientales y están relacionados con la
                actividad minera. Siete están en Espinar y Chumbivilcas, que son
                parte del famoso y siempre conflictivo Corredor Minero del Sur.
                La representante de la Defensoría del Pueblo en Cusco, Rosa
                Santa Cruz, sostuvo que estos conflictos activos y latentes
                merecen urgente atención.
              </p>
              <p>
                Los ciudadanos Melchora Surco, Germán Salcedo y Herbert Huamán
                viven en territorios que se han convertido en un enorme emporio
                de producción minera. Cada día ven cómo la riqueza mineral sale
                y la pobreza se queda. Ellos viven en pueblos que reciben
                millones de soles por canon y regalías mineras, pero donde
                todavía hay pobreza. Son testigos de que las municipalidades no
                hacen un buen uso de los fondos del canon. Así, en algunas
                comunidades las casas todavía son construcciones de adobe con
                techo de calamina o ichu. Adentro, el piso es de tierra. Sus
                alimentos son preparados en un fogón alimentado con leña.
                Consumen agua de manantiales o acequias. Y la mayoría de niños
                tienen anemia y destruición.
              </p>
            </Fade>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotaCusco;
